import { Http } from '../../../../support';

const initialState = {
  busy: false,
  selectedTab: 'todo',
  filters: {
    page: 1,
    search: '',
  },
  data: [],
  pagination: {
    limit: 25,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.comprobantes.list = {
      ...external.receptores.comprobantes.list,
      ...data,
    };
  });
};

const setListData = (store, data) => {
  store.setState((state) => {
    const { external } = state;

    const newList = [].concat([data], external.receptores.comprobantes.list.data);

    external.receptores.comprobantes.list = {
      ...external.receptores.comprobantes.list,
      data: newList,
      pagination: {
        ...external.receptores.comprobantes.list.pagination,
        count: parseInt(external.receptores.comprobantes.list.pagination.count || 0) + 1,
      },
    };
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.comprobantes.list = {
      ...external.receptores.comprobantes.list,
      busy: true,
      filters: {
        ...external.receptores.comprobantes.list.filters,
        ...meta,
      },
      pagination: {
        ...external.receptores.comprobantes.list.pagination,
        limit: meta.limit ?? 25,
      },
    };
  });

  try {
    const { list } = store.state.external.receptores.comprobantes;

    const params = {
      ...list.filters,
      ...meta,
      limit: list.pagination.limit,
    };

    const response = await Http.get('ext/receptores/facturas', { params });

    store.setState((state) => {
      const { external } = state;

      external.receptores.comprobantes.list = {
        ...external.receptores.comprobantes.list,
        busy: false,
        data: response.data,
        pagination: {
          ...external.receptores.comprobantes.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      const { external } = state;

      external.receptores.comprobantes.list = {
        ...external.receptores.comprobantes.list,
        busy: false,
        error: error.data || error,
      };
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    const { external } = state;

    external.receptores.comprobantes.list = {
      ...external.receptores.comprobantes.list,
      ...initialState,
    };
  });
};

const ExternalComprobanteListStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    setListData,
    paginate,
    reset,
  },
};

export default ExternalComprobanteListStore;
